export default __webpack_public_path__ + "static/media/goal_EN.fbdce3b9.png";